




































































































































































































import schema from 'async-validator'
import {
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
} from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import FieldError from '@/components/FieldError.vue'
import FieldErrorGroup from '@/components/FieldErrorGroup.vue'

import { MIN_AGE } from '@/models/customer'
import ErrorEntities from '@/models/error-entities'
import Passenger from '@/models/passenger'
import RegistrationData from '@/models/registration-data'

import GroupedErrorValidationMixin from '@/mixins/GroupedErrorValidationMixin.vue'
import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    FieldError,
    FieldErrorGroup,
  },
})
export default class RegistrationForm extends mixins(
  GroupedErrorValidationMixin,
) {
  @Prop() serverErrors!: ErrorEntities
  @Prop() passenger!: Passenger
  @Prop() pending!: boolean
  @Ref() readonly registrationForm!: Form
  @Ref() readonly firstNameInput!: Input

  readonly rules = {
    title: [
      { required: true, message: 'Please enter your', trigger: 'change' },
    ],
    firstName: [
      { required: true, message: 'Please enter your', trigger: 'blur' },
    ],
    lastName: [
      { required: true, message: 'Please enter your', trigger: 'blur' },
    ],
    email: [
      { required: true, message: 'Please enter your Email', trigger: 'blur' },
      { type: 'email', message: 'Oops! Invalid Email', trigger: 'blur' },
    ],
    age: [
      { required: true, message: 'Please enter your', trigger: 'change' },
      {
        type: 'number',
        max: this.maxBirthYear,
        message: 'Customer must be at least 17 years old',
        trigger: 'change',
      },
    ],
    nationality: [
      { required: true, message: 'Please enter your', trigger: 'change' },
    ],
    countryCode: [
      { required: true, message: 'Please enter your', trigger: 'change' },
    ],
    tel: [{ required: true, message: 'Please enter your', trigger: 'blur' }],
    password: [
      {
        required: true,
        message: 'Please enter your Password',
        trigger: 'blur',
      },
      {
        min: 8,
        message: 'Password should be at least 8 characters long',
        trigger: 'blur',
      },
    ],
  }

  readonly alteredValidationFieldNames: { [key: string]: string } = {
    age: 'birthYear',
    tel: 'phoneNumber',
  }

  readonly validator = new schema(this.rules)

  form: RegistrationData = {
    email: '',
    password: '',
    title: '',
    firstName: '',
    lastName: '',
    nationality: '',
    countryCode: '',
    tel: '',
    age: null,
  }

  formErrors: ErrorEntities = {}

  get nationalities() {
    return this.$store.getters.nationalities
  }

  get countries() {
    return this.$store.getters.countries
  }

  get yearOptions(): number[] {
    const years: number[] = []
    const currentYear = new Date().getFullYear()

    for (let n = MIN_AGE; n <= 100; n++) {
      years.push(currentYear - n)
    }

    return years
  }

  get maxBirthYear() {
    return new Date().getFullYear() - MIN_AGE
  }

  created() {
    this.$store.dispatch(ProfileDataActionTypes.LoadNationalities)
    this.$store.dispatch(ProfileDataActionTypes.LoadCountries)

    if (this.passenger) {
      this.fillInForm()
    }
  }

  fillInForm() {
    const { form, passenger, $_ } = this
    const prefilledFields = $_.pick(
      passenger,
      Object.keys(form),
    ) as RegistrationData

    this.form = { ...form, ...prefilledFields }
  }

  handleRegistration() {
    this.registrationForm.validate((isValid) => {
      if (isValid) {
        this.$emit('on-registration', this.form)
      }
    })
  }

  focusFirstName() {
    setTimeout(() => this.firstNameInput.focus())
  }
}
